<script setup>
import InputText from "primevue/inputtext";
import Dropdown from "primevue/dropdown";
import { usePage } from "@inertiajs/inertia-vue3";
import { computed } from "vue";

const props = defineProps([
    'form',
    'roleOptions',
    'companyOptions',
    'isSuperAdmin',
])

const authUser = computed(() => usePage().props.value.auth.user)
const isSelf = computed(() => props.form.id && authUser.value && props.form.id === authUser.value.id)
</script>
<template>
    <div class="grid grid-cols-2 gap-4 mb-5">
        <div>
            <label class="font-bold">Email</label>

            <InputText
                v-model="form.email"
                type="email"
                class="w-full"
            />
        </div>

        <div>
        </div>

        <div>
            <label class="font-bold">Passwort</label>

            <InputText
                v-model="form.password"
                type="password"
                class="w-full"
            />
        </div>

        <div>
            <label class="font-bold">Passwortbestätigung</label>

            <InputText
                v-model="form.password_confirmation"
                type="password"
                class="w-full"
            />
        </div>

        <div>
            <label class="font-bold">Benutzerrolle</label>

            <div v-if="form.role === 'customer'" class="py-2">
                Kunde
            </div>

            <div v-else-if="isSelf" class="py-2">
                {{ form.roleName || form.role }} (Eigener Account)
            </div>
            
            <Dropdown
                v-else
                v-model="form.role"
                class="w-full"
                :options="roleOptions"
                optionLabel="label"
                optionValue="value"
            ></Dropdown>
        </div>

        <div v-if="isSuperAdmin">
            <label class="font-bold">Unternehmen</label>

            <Dropdown
                v-model="form.company_id"
                class="w-full"
                :options="companyOptions"
                optionLabel="label"
                optionValue="value"
                placeholder="Wählen Sie ein Unternehmen"
                filter
            ></Dropdown>
        </div>

        <div v-else>
        </div>

        <div>
            <label class="font-bold">Forename</label>

            <InputText
                v-model="form.forename"
                type="text"
                class="w-full"
            />
        </div>

        <div>
            <label class="font-bold">Surname</label>

            <InputText
                v-model="form.surname"
                type="text"
                class="w-full"
            />
        </div>

        <div>
            <label class="font-bold">Telefon</label>

            <InputText
                v-model="form.phone"
                type="text"
                class="w-full"
                maxlength="10"
            />
        </div>

        <div>
            <label class="font-bold">Natel</label>

            <InputText
                v-model="form.mobile"
                type="text"
                class="w-full"
                maxlength="10"
            />
        </div>
    </div>
</template>
